import { USER_MANUAL_ACTION } from "../constant";

const initState = {
  categoryList: []
};

export const userManualReducer = (state = initState, action) => {
  switch (action.type) {
    case USER_MANUAL_ACTION._SUCCESS:
      return { ...state, categoryList: action.payload };

    default:
      return state;
  }
};
